import { CentralizedUrlAdapter } from '../adapters/CentralizedUrlAdapter';
import {
  BillingFormSubmissionActionsController,
  PaymentMethodsController,
  BillingInfoFormController,
  ThankYouController,
  UpdateMoretonBayBillingController,
} from '../controllers';
import { initializerHelpers } from '../helpers';
import type { Listeners } from '../helpers';
import {
  PaymentMethodsManager,
  BillingInfoFormManager,
  UpdateBillingManager,
  RouterNonUiManager,
  AlertManager,
  ThankYouManager,
} from '../managers';

export class MoretonBayBillingInitializer {
  public listeners: Listeners;

  // managers
  private billingInfoForm: BillingInfoFormManager;

  private paymentMethods: PaymentMethodsManager;

  private updateBilling: UpdateBillingManager;

  private alertManager: AlertManager;

  private routerManager: RouterNonUiManager;

  private thankYouManager: ThankYouManager;

  // controllers
  public thankYouController: ThankYouController;

  // init methods
  public billingInfoFormInit: BillingInfoFormManager['billingInfoFormInit'];

  public paymentMethodsInit: PaymentMethodsManager['paymentMethodsInit'];

  public updateBillingInit: UpdateBillingManager['updateBillingInit'];

  public routerNonUiInit: RouterNonUiManager['routerNonUiInit'];

  public alertInit: AlertManager['alertInit'];

  public thankYouInit: ThankYouManager['thankYouInit'];

  constructor() {
    const urlAdapter = new CentralizedUrlAdapter();

    this.billingInfoForm = new BillingInfoFormManager();
    this.paymentMethods = new PaymentMethodsManager(urlAdapter);
    this.updateBilling = new UpdateBillingManager();
    this.alertManager = new AlertManager();
    this.thankYouController = new ThankYouController(this.alertManager);
    this.routerManager = new RouterNonUiManager();
    this.thankYouManager = new ThankYouManager();

    this.billingInfoFormInit = this.billingInfoForm.billingInfoFormInit;
    this.paymentMethodsInit = this.paymentMethods.paymentMethodsInit;
    this.updateBillingInit = this.updateBilling.updateBillingInit;
    this.routerNonUiInit = this.routerManager.routerNonUiInit;
    this.alertInit = this.alertManager.alertInit;
    this.thankYouInit = this.thankYouManager.thankYouInit;

    this.listeners = this.initializeControllers();
  }

  private initializeControllers() {
    const controllers = [
      new BillingInfoFormController(this.billingInfoForm, this.paymentMethods),
      new PaymentMethodsController(this.paymentMethods, this.alertManager, this.updateBilling),
      new UpdateMoretonBayBillingController(
        this.paymentMethods,
        this.billingInfoForm,
        this.updateBilling,
        this.alertManager,
        this.routerManager
      ),
      new BillingFormSubmissionActionsController(this.updateBilling),
    ];

    initializerHelpers.initControllers(controllers);

    return initializerHelpers.createListeners(controllers);
  }
}
